export default {
  activity: {
    key: ['activity'],
    path: 'activity',
  },
}
